import linkAccountRegisterRequest from 'purchase/checkout/linkAccount/linkAccountModel';
// eslint-disable-next-line import/no-cycle
import { getUrl } from 'purchase/checkout/linkAccount/linkAccountUtility';

class LinkAccountConfirmationModal {
	constructor() {
		this.dataDivId = 'customerAccountLinkRegisterData';
		this.dataDiv = document.getElementById(this.dataDivId);
		const button = document.getElementById(
			'customerAccountLinkConfirmationModalActionLink',
		);
		if (button) {
			button.addEventListener('click', this.register.bind(this));
		}
	}

	register() {
		const url = getUrl(this.dataDivId);
		const data = this.getFormData();
		return linkAccountRegisterRequest(data, url)
			.then(() => this.coreMetricsSuccessRedirect())
			.catch(() => new Error());
	}

	getFormData() {
		return {
			customerNumber: this.dataDiv.dataset.customerNumber,
			phoneNumber: this.dataDiv.dataset.phoneNumber,
			postalCode: this.dataDiv.dataset.postalCode,
		};
	}

	coreMetricsSuccessRedirect(location = window.location) {
		if (this.dataDiv) {
			location.assign(this.dataDiv.getAttribute('data-success-url'));
		} else {
			location.reload();
		}
	}
}

export default LinkAccountConfirmationModal;
